import { $, _, Fetch } from "@utils";
import recordSVG from "./assets/svg/record.svg";
import InfoSVG from "./assets/svg/info.svg";
import nextSVG from "./assets/svg/next.svg";
// import QuizQuestions from "../dmvQuestions.json";
class Quiz {
  wrapperEl = null;
  previousIndex = null;
  quizIndex = 0;
  quizLength = 0;
  quizTitle = null;
  prevQuizIndex = null;
  containerEl = null;
  mainHeaderEl = null;
  questionEl = null;
  optionInner = null;
  optionFaceFront = null;
  optionFaceBack = null;
  nextBtnEl = null;
  answerEl = null;
  answeredWith = null;
  correctAnswerIndex = null;
  explanation = null;
  explanationContainer = null;
  explanationWrapper = null;
  buttonOptionContainer = null;
  recordWrapper = null;

  numbers = [];
  quizOptionArray = [];
  quizData = {};
  face = "front";
  recordedAnswers = [];
  boundGradeAnswer = this.gradeAnswer.bind(this);
  get path() {
    const url = new URL(window.location);
    const paths = url.pathname.trim().split("/");
    return paths[2].replaceAll("/", "");
  }

  // Get questions remaining
  get questionsRemaining() {
    return this.numbers.length - this.index;
  }

  get fetchQuizData() {
    // this.quizIndex = this.rand();
    return new Promise(async (res, rej) => {
      const req = await Fetch("/quizData", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "pn=" + this.path + "&qi=" + this.quizIndex,
      });

      const response = await req.json();

      res(response);
    });
  }

  constructor() {
    // Add the stylesheet
    // _().addStyle("/css/quiz.css");

    // fetch the title and the length of the quiz
    // before begining

    Fetch("/quizData", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: "init=true&pn=" + this.path,
    })
      .then((res) => res.json())
      .then((json) => {
        this.quizLength = json.length;
        this.quizTitle = json.title;

        // Add the quiz Wrapper
        this.wrapperEl = document.createElement("div");
        this.wrapperEl.classList.add("__quiz-wrapper");
        //------------------------------------------------------
        // Add the quiz Container
        this.containerEl = document.createElement("div");
        this.containerEl.classList.add("__quiz-container");
        this.wrapperEl.appendChild(this.containerEl);
        //------------------------------------------------------------------
        this.headerEl = document.createElement("header");
        this.headerEl.classList.add("__quiz-header");
        this.wrapperEl.prepend(this.headerEl);
        // Quiz Title
        this.quizTitleEl = document.createElement("span");
        this.quizTitleEl.classList.add("__quiz-quizTitle");
        this.quizTitleEl.textContent = this.quizTitle;
        this.headerEl.appendChild(this.quizTitleEl); // Append to the containerEl

        //---------------------------------------------------------------------------
        //------------------------------------------------------------------------------
        // Add a progress bar
        this.progressWrapperEl = document.createElement("div");
        this.progressWrapperEl.classList.add("__quiz-progressBarWrapper");
        this.progressSVGEl = document.createElement("div");
        this.progressSVGEl.classList.add("__quiz-progressSVG");

        this.progressSVGEl.innerHTML = `<svg width="100%" height="100%" viewBox="0 0 180 180"><circle class="__quiz-progress-bg" cx="90" cy="90" r="80" /><circle class="__quiz-progress-fill" cx="90" cy="90" r="80" /><text class="__quiz-progress-text" x="90" y="100" text-anchor="middle">0 / 0</text></svg>`;

        this.progressWrapperEl.appendChild(this.progressSVGEl);
        this.headerEl.appendChild(this.progressSVGEl);
        // Option Wrapper
        this.optionWrapper = document.createElement("div");
        this.optionWrapper.classList.add("__quiz-optionWrapper");
        this.optionWrapper.dataset.state = "preload";
        this.containerEl.appendChild(this.optionWrapper);
        //-------------------------------------------------------------------------
        // Option Container
        this.optionContainer = document.createElement("div");
        this.optionContainer.classList.add("__quiz-optionContainer");
        this.optionWrapper.appendChild(this.optionContainer);
        //--------------------------------------------------------------------
        //---------------------------------------------------------------------
        //Add Question element
        this.questionEl = document.createElement("span");
        this.questionEl.classList.add("__quiz-question");
        this.optionWrapper.prepend(this.questionEl); // Append to the containerEl
        //--------------------------------------------------------------------
        // Add OptionInner
        this.optionInner = document.createElement("div");
        this.optionInner.classList.add("__quiz-optionInner");
        this.optionContainer.appendChild(this.optionInner);
        //----------------------------------------------------------------------

        // ButtonOptionContainer
        this.buttonOptionContainer = document.createElement("div");
        this.buttonOptionContainer.classList.add(
          "__quiz-buttonOptionContainer",
        );
        this.optionContainer.appendChild(this.buttonOptionContainer);
        //----------------------------------------------------------------------
        // Explanation elements
        this.explanationContainer = document.createElement("div");
        this.explanationContainer.classList.add("__quiz-explanation");
        this.buttonOptionContainer.appendChild(this.explanationContainer);
        //-----------------------------------------------------------------------
        this.addOptions();
        this.questionsLeftToGo = 0;

        $("#app").appendChild(this.wrapperEl);

        // Add a record button
        const recordEl = document.createElement("div");
        recordEl.classList.add("__quiz-recordButton");
        recordEl.addEventListener("click", this.openRecordModel.bind(this));
        recordEl.innerHTML = `<span class="__quiz-recordSVG">${recordSVG}</span>`;
        $("#app").appendChild(recordEl);
        // Create record wrapper
        this.recordWrapper = document.createElement("div");
        this.recordWrapper.classList.add("__quiz-recordWrapper");
        $("#app").appendChild(this.recordWrapper);
        this.handleObserve();

        // create the shuffled question order once
        this.yatesShuffle();
        this.updateQuiz();
        window.quiz = this;
      });
  }

  handleObserve() {
    //----------------------------------------------------------------------------
    // Observe the height of OptionFaceFront
    // To set the height for the optionInner since the
    // FaceFront is absolute and does not expand the
    // Parent  div
    const innerObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const face = entry.target.classList.contains("__quiz-option-front")
          ? "front"
          : "back";

        // Ignore the hidden side
        if (face !== this.face) return;

        const styles = getComputedStyle(entry.target);
        const paddingTop = parseFloat(styles.paddingTop);
        const paddingBottom = parseFloat(styles.paddingBottom);
        this.optionInner.style.height =
          entry.contentRect.height + paddingBottom + paddingTop + "px";
      }
    });

    // innerObserver.observe(document.querySelector(".__quiz-face"));
    document.querySelectorAll(".__quiz-face").forEach((face) => {
      innerObserver.observe(face);
    });

    const questionObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const styles = getComputedStyle(entry.target);
        const paddingTop = parseFloat(styles.paddingTop);
        const marginTop = parseFloat(styles.marginTop);
        const marginBottom = parseFloat(styles.marginBottom);
        const paddingBottom = parseFloat(styles.paddingBottom);
        this.optionContainer.style.top =
          entry.contentRect.height +
          paddingTop +
          paddingBottom +
          marginTop +
          marginBottom +
          "px";
      }
    });

    questionObserver.observe($(".__quiz-question"));

    const wrapperObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const currentEl = entry.target.classList.contains(
          "__quiz-optionContainer",
        )
          ? "optionContainer"
          : "questions";

        const styles = getComputedStyle(entry.target);

        const paddingTop = parseFloat(styles.paddingTop);
        const marginTop = parseFloat(styles.marginTop);
        const marginBottom = parseFloat(styles.marginBottom);
        const top = parseFloat(styles.top);
        const paddingBottom = parseFloat(styles.paddingBottom);
        this.optionWrapper.style.height =
          entry.contentRect.height +
          marginTop +
          marginBottom +
          paddingBottom +
          paddingTop +
          top +
          "px";
      }
    });

    wrapperObserver.observe($(".__quiz-optionContainer"));
    // wrapperObserver.observe($(".__quiz-optionInner"));
    // wrapperObserver.observe($(".__quiz-question"));
  }

  // Create new spans and elements for creating a new
  //  Record to the Record Model that pops up from
  // The bottom
  updateRecordModel() {
    // Add the most recent recorded record

    if (!document.querySelector(".__quiz-recordContainer")) {
      this.recordContainer = document.createElement("div");
      this.recordContainer.classList.add("__quiz-recordContainer");
      this.recordWrapper.append(this.recordContainer);
    }

    // get the current record
    // console.log(this.recordedAnswers[this.recordedAnswers.length - 1]);
    const record = this.recordedAnswers[this.recordedAnswers.length - 1];
    const recordContainer = document.createElement("div");
    const recordClass = record.answeredCorrectly
      ? "__quiz-record-answeredCorrectly"
      : "__quiz-record-notAnsweredCorrectly";
    const recordSpan = document.createElement("span");
    recordSpan.dataset.score = record.score;
    recordSpan.dataset.id = record.id;
    recordSpan.classList.add(record.className);
    recordSpan.textContent = record.question;
    this.recordContainer.prepend(recordSpan);
  }

  // Open the record model that pops up from the bottom
  openRecordModel() {
    this.recordWrapper.classList.add("__quiz-recordWrapper-show");
    this.recordOverlay = document.createElement("div");
    this.recordOverlay.classList.add("__quiz-recordOverlay");
    this.recordOverlay.addEventListener(
      "click",
      this.closeRecordModel.bind(this),
    );
    document.body.appendChild(this.recordOverlay);
  }

  // Closes the Record Model that pop up from the
  // Bottom
  closeRecordModel() {
    this.recordOverlay.remove();
    this.recordWrapper.classList.remove("__quiz-recordWrapper-show");
  }

  // Adds options for the quiz selection
  addOptions() {
    for (let i = 0; i <= 1; i++) {
      const face = i === 0 ? "front" : "back";
      // Quiz option face front
      const optionFace = document.createElement("div");
      optionFace.classList.add("__quiz-face", `__quiz-option-${face}`);
      this.containerEl.appendChild(optionFace);

      //----------------------------------------------------------------
      // Option1El
      let option = null;
      for (let i = 0; i < 4; i++) {
        option = document.createElement("span");
        option.dataset.option = i;
        option.classList.add("__quiz-option");
        option.addEventListener("click", this.boundGradeAnswer);
        optionFace.appendChild(option);
      }
      this.optionInner.appendChild(optionFace);
    }
  }

  // Grade the answer that the user makes and
  // Then applies the classes to indicate if it
  // was correct or wrong
  async gradeAnswer(el) {
    //Immediately remove the click event listener once first element is clicked
    const options = document.querySelectorAll(".__quiz-option");
    options.forEach((option) => {
      option.removeEventListener("click", this.boundGradeAnswer);
    });
    this.answeredWith = Number(el.target.dataset.option);
    // const answerResults = answer === this.correctAnswerIndex;
    const req = await Fetch("/quizData", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body:
        "checkAnswer=" +
        this.answeredWith +
        "&pn=" +
        this.path +
        "&qi=" +
        this.quizIndex,
    });
    const res = await req.json();
    const isCorrect = res.correct;
    this.explanation = res.explanation;
    this.correctAnswerIndex = res.correctAnswerIndex;
    this.recordAnswers(isCorrect, this.answerWith);
    const elNode = el.target.closest(".__quiz-option");

    if (isCorrect === true) {
      elNode.classList.add("__quiz-optionCorrect");
    } else {
      elNode.classList.add("__quiz-optionIncorrect");
      // Highlight the correct one
      const options = document.querySelectorAll(".__quiz-option");
      setTimeout(() => {
        options.forEach((option) => {
          const optNumber = Number(option.dataset.option);
          if (optNumber === this.correctAnswerIndex) {
            option.classList.add(
              "__quiz-optionCorrect",
              "__quiz-optionCorrectFadeIn",
            );
          }
        });
      }, 400);
    }
    setTimeout(() => {
      this.toggleExplanation();
    }, 1200);

    setTimeout(() => {
      this.showNextButton();
    }, 700);
  }

  // Toggle the little explanation that pops up after
  // Answering the quiz question
  toggleExplanation() {
    this.explanationContainer.classList.add("__quiz-explanation-show");
    this.explanationContainer.innerHTML = `<span class="__quiz-explanation-text">${InfoSVG} ${this.explanation}</span>`;
  }

  // Records the answer to recordedAnswers Array as well
  // as applies a score to each word along with some classes as well
  recordAnswers(correctlyAnswered, chosenAnswerOptionIndx) {
    const quiz_id = this.quizData.id;
    const choosenOptionAnswer = this.quizData.options[chosenAnswerOptionIndx];

    // See if we can't find the index for this quiz_id
    const record = this.recordedAnswers.find(
      (recorded) => recorded.id === quiz_id,
    );

    if (record === undefined) {
      // console.log("Created a new record");
      this.recordedAnswers.push({
        id: quiz_id,
        score: correctlyAnswered ? 1 : -1,
        question: this.quizData.question,
        correctAnswer: this.quizData.options[this.correctAnswerIndex],
        answeredWith: this.answeredWith,
        gotAnswer: correctlyAnswered ? "Correct" : "Wrong",
        answered: {
          correct: correctlyAnswered ? 1 : 0,
          wrong: correctlyAnswered ? 0 : 1,
        },
        className: correctlyAnswered
          ? "__quiz-record-optionCorrect"
          : "__quiz-record-optionIncorrect",
        options: {
          [chosenAnswerOptionIndx]: {
            answer: choosenOptionAnswer,
            score: 1,
          },
        },
      });
    } else {
      // Update the record
      record.score += correctlyAnswered ? 1 : record.score === 1 ? -2 : -1;
      if (correctlyAnswered) {
        record.answered.correct++;
      } else {
        record.answered.wrong++;
      }

      record.answeredWith = choosenOptionAnswer;
      record.gotAnswer = correctlyAnswered ? "Correct" : "Wrong";
      record.className =
        correctlyAnswered && record.score >= 1
          ? "__quiz-optionCorrect"
          : correctlyAnswered && record.score <= 0
            ? "__quiz_optionCaution"
            : !correctlyAnswered && record.score >= 1
              ? "__quiz-optionWarning"
              : "__quiz_optionIncorrect";

      // If the option exist already with this record
      // Update the options score
      if (record.options[chosenAnswerOptionIndx]) {
        record.options[chosenAnswerOptionIndx].score++;
      } else {
        // If the option does not exist, then add it
        // Add the option to the list

        record.options = {
          ...record.options,
          [chosenAnswerOptionIndx]: {
            answer: chooseOptionAnswer,
            score: 1,
          },
        };
      }
    }

    this.updateRecordModel();
  }

  showNextButton() {
    // const face = this.face === "font" ? "back" : "front";
    if (!document.querySelector(".__quiz-nextButton")) {
      const nextButton = document.createElement("span");
      nextButton.classList.add("__quiz-nextButton", "__quiz-nextButton-hide");
      nextButton.innerHTML = nextSVG;
      nextButton.addEventListener("click", this.nextQuestion.bind(this));
      this.buttonOptionContainer.appendChild(nextButton);
      // Change the state on the wrapper to loaded
      this.optionWrapper.dataset.state = "loaded";
      this.optionWrapper.addEventListener("transitionend", () => {
        setTimeout(() => {
          nextButton.classList.remove("__quiz-nextButton-hide");
        }, 200);
      });
    }
  }

  toggleVisability() {
    if ($(".__quiz-nextButton")) {
      $(".__quiz-nextButton").remove();
    }
    this.explanationContainer.classList.remove("__quiz-explanation-show");
  }

  nextQuestion() {
    // Reset all of the options classes
    const options = document.querySelectorAll(".__quiz-option");
    options.forEach((option) => {
      option.className = "__quiz-option";
      option.addEventListener("click", this.boundGradeAnswer);
    });

    this.toggleVisability();
    this.face = this.face === "front" ? "back" : "front";
    this.updateQuiz();
    $(".__quiz-optionContainer").classList.toggle("flip");
  }

  yatesShuffle() {
    this.numbers = [];
    for (let i = 0; i < this.quizLength; i++) {
      this.numbers.push(i);
    }

    // Fisher–Yates shuffle
    for (let i = this.numbers.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.numbers[i], this.numbers[j]] = [this.numbers[j], this.numbers[i]];
    }

    this.index = 0;
  }

  rand() {
    // if we've gone through every question,
    // start over with a new shuffle
    if (this.index >= this.numbers.length) {
      this.yatesShuffle();
    }
    return this.numbers[this.index++];
    // this.yatesShuffle();
    // if (this.index >= this.numbers.length) return null;
    // return this.numbers[this.index++];
  }

  updateQuiz() {
    this.quizIndex = this.rand();

    this.fetchQuizData.then((quizData) => {
      this.quizData = quizData;

      // const rand = this.rand();
      // this.quiz = QuizQuestions[rand];
      this.updateProgress();
      const optionFaceContainer = $(`.__quiz-option-${this.face}`);
      const options = optionFaceContainer.querySelectorAll(".__quiz-option");
      const question = document.querySelector(".__quiz-question");
      question.textContent = this.quizData.question;
      // this.correctAnswerIndex = Number(this.quiz.correct);
      this.quizData.options.forEach((option, index) => {
        options[index].innerHTML =
          `<span class="__quiz-optionText">${option}</span>`;
      });

      // requestAnimationFrame(() => {
      //   const activeFace = document.querySelector(`.__quiz-option-${this.face}`);
      //   this.optionInner.style.height = activeFace.offsetHeight + "px";
      // });
    });
  }

  updateProgress() {
    const circle = this.progressSVGEl.querySelector(".__quiz-progress-fill");

    const text = this.progressSVGEl.querySelector(".__quiz-progress-text");

    const total = this.numbers.length;
    const completed = this.index;

    const radius = 80;
    const circumference = 2 * Math.PI * radius;

    const percent = completed / total;

    circle.style.strokeDasharray = circumference;

    circle.style.strokeDashoffset = circumference * (1 - percent);

    text.textContent = `${completed} / ${total}`;
  }
}
export default Quiz;
